<ng-container *ngIf="ctx" [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-maintenance-parts-boxed-layout *ngSwitchDefault [ctx]="ctx" [selection]="selection"></app-maintenance-parts-boxed-layout>
  <app-maintenance-parts-scroll-layout *ngSwitchCase="1" [ctx]="ctx" [selection]="selection"></app-maintenance-parts-scroll-layout>
</ng-container>